// extracted by mini-css-extract-plugin
export var cardHeader = "_uc-0";
export var reorderHandle = "_uc-3";
export var titleArea = "_uc-1";
export var titleAreaWithHandle = "_uc-2";